/* eslint-disable react/jsx-no-bind */
import React, { useContext, useEffect, useState } from 'react';
import { Link, useMatch, useNavigate } from 'react-router-dom';

import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { BsDownload } from 'react-icons/bs';
import { MdArrowBack, MdContentCopy, MdDownload } from 'react-icons/md';

import { Grid2, Input } from '@mui/material';
import api, { authHeader } from '../../../../../../services/API/apiConfig';
import { Dropzone } from '../../../../../components/singleComponents/dropzone/Dropzone';
import { Header } from '../../../../../components/singleComponents/headers';

import GlobalContext from '../../../../../../context/GlobalContext';
import {
  AttachmentsListStyled,
  AttachmentsStyled,
  BoxStyled,
  ButtonCopyStyled,
  CardTitleStyled,
  DetailedPayableStyled,
  FileNameStyled,
  HeadersLinkStyled,
  ItemsTitleStyled,
  LinksAndTotalStyled,
  MobileDivStyled,
  PageTitleStyled,
  PayableInfoStyled,
  RootStyled,
  TitleContainerStyled,
} from './index.styles';

const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

export function DetailedPayables() {
  const navigate = useNavigate();
  const match = useMatch('/detailed-payable/:id');
  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);

  const matches = useMediaQuery('(max-width:950px)');

  const baseURL = process.env.REACT_APP_API;
  const protocol =
    process.env.REACT_APP_NODE_ENV === 'development' ? 'http' : 'https';

  const [payable, setPayable] = useState(null);
  const [budgetItem, setBudgetItem] = useState([]);
  const [payablesItems, setPayableItems] = useState([]);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [files, setFiles] = useState([]);
  const [attachment, setAttachment] = useState([]);
  const [loading, setLoading] = useState(true);

  const payableID = match ? match.params.id : null;
  const options = { headers: authHeader() };

  function handleGoBack() {
    navigate(-1);
  }

  const handleCloseSnackBar = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };

  async function downloadAttachment(fileId) {
    api
      .get(`/payables/${payableID}/attachments/${fileId}`, options)
      .then((res) => {
        const { data } = res.data;
        window.open(`${protocol}://${subdomain}.${baseURL}${data.path.url}`);
      });
  }

  async function getFiles() {
    await api.get(`/payables/${payableID}/attachments`, options).then((res) => {
      const { data } = res.data;
      setFiles(data);
    });
  }

  const handlePayableBudgetItems = () => {
    const currentPayableItems = [];
    for (let i = 0; i < budgetItem.length; i += 1) {
      for (let j = 0; j < payable.payable_items.length; j += 1) {
        if (payable.payable_items[j].item_id === budgetItem[i].id) {
          currentPayableItems.push({
            ...budgetItem[i],
            total: payable.payable_items[j].total,
          });
        }
      }
    }

    setPayableItems(currentPayableItems);
  };

  useEffect(() => {
    api.get(`/payables/${payableID}`, options).then((res) => {
      const { data } = res.data;
      setPayable(data);
    });

    getFiles();
  }, []);

  useEffect(() => {
    if (payable !== null) {
      setLoading(false);
      if (payable.construction.id) {
        api
          .get(`/constructions/${payable.construction.id}/budgets?array=true`, {
            headers: authHeader(),
          })
          .then((res) => {
            const { data } = res.data;
            setBudgetItem(
              data.items?.filter((item) => item.has_payables) || []
            );
          });
      }
    }
  }, [payable]);

  useEffect(() => {
    setTimeout(() => {
      getFiles();
    }, 1500);
  }, [attachment]);

  useEffect(() => {
    handlePayableBudgetItems();
  }, [budgetItem]);

  return (
    <>
      <RootStyled>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={4000}
          onClose={handleCloseSnackBar}
        >
          <Alert
            onClose={handleCloseSnackBar}
            severity="success"
            sx={{ width: '20%' }}
          >
            Copiado!
          </Alert>
        </Snackbar>
        <TitleContainerStyled container alignItems="center">
          <IconButton onClick={handleGoBack} size="large">
            <MdArrowBack size={25} />
          </IconButton>
          <PageTitleStyled variant="h2">Detalhes de lançamento</PageTitleStyled>
        </TitleContainerStyled>
        <div>
          {payable && (
            <Grid2
              container
              direction={matches ? 'column' : 'row'}
              justifyContent="center"
            >
              <BoxStyled item sx={{ width: matches ? '100%' : '50%' }}>
                <Grid2 container spacing={2}>
                  <Grid2 item>
                    <PayableInfoStyled variant="h3">
                      Informações sobre o lançamento
                    </PayableInfoStyled>
                  </Grid2>
                  <Grid2 item sx={{ width: '100%' }}>
                    <TextField
                      style={{ pointerEvents: 'none' }}
                      label="Fornecedor"
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      value={payable.supplier.name}
                      fullWidth
                    />
                  </Grid2>
                  <Grid2 item sx={{ width: '100%' }}>
                    <Input
                      style={{ pointerEvents: 'none' }}
                      label="Código de boleto"
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      value={payable.bank_slip_number}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            style={{ pointerEvents: 'auto' }}
                            position="end"
                          >
                            <CopyToClipboard
                              text={payable.bank_slip_number}
                              onCopy={() => setOpenSnackBar(!openSnackBar)}
                            >
                              <IconButton
                                disabled={!payable.bank_slip_number}
                                size="large"
                              >
                                <MdContentCopy size={19} />
                              </IconButton>
                            </CopyToClipboard>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid2>
                  <Grid2 item sx={{ width: '100%' }}>
                    <TextField
                      style={{ pointerEvents: 'none' }}
                      label="Vencimento"
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      value={payable.due}
                      fullWidth
                    />
                  </Grid2>
                  <Grid2 item sx={{ width: '100%' }}>
                    <TextField
                      style={{ pointerEvents: 'none' }}
                      label="Descrição"
                      variant="outlined"
                      value={payable.description}
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      fullWidth
                    />
                  </Grid2>
                  {payable.category && (
                    <Grid2 item sx={{ width: '100%' }}>
                      <TextField
                        style={{ pointerEvents: 'none' }}
                        fullWidth
                        variant="outlined"
                        label="Categoria do fornecedor"
                        slotProps={{
                          inputLabel: { shrink: true },
                        }}
                        value={payable?.category?.name}
                      />
                    </Grid2>
                  )}
                  <Grid2 item sx={{ width: '100%' }}>
                    <TextField
                      style={{ pointerEvents: 'none' }}
                      label="Valor"
                      variant="outlined"
                      value={new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(payable.total)}
                      fullWidth
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                    />
                  </Grid2>
                  {payable?.payable_items?.length !== 0 && (
                    <>
                      <ItemsTitleStyled item sx={{ width: '100%' }}>
                        <Typography variant="h4" style={{ color: '#1C1C1C' }}>
                          Itens associados ao orçamento
                        </Typography>
                      </ItemsTitleStyled>
                      {payablesItems.map((item, index) => (
                        <>
                          <Grid2 item sx={{ width: '100%' }}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              slotProps={{
                                inputLabel: { shrink: true },
                              }}
                              label="Categoria do fornecedor"
                              style={{ marginTop: 16, pointerEvents: 'none' }}
                              value={
                                payable.payable_items[index]?.category?.name
                              }
                            />
                          </Grid2>
                          <Grid2 item sx={{ width: '100%' }}>
                            <TextField
                              style={{ pointerEvents: 'none' }}
                              fullWidth
                              variant="outlined"
                              slotProps={{
                                inputLabel: { shrink: true },
                              }}
                              label="Item do orçamento"
                              value={`${item.item_num} - ${item.description}`}
                            />
                          </Grid2>
                          <Grid2 item sx={{ width: '100%' }}>
                            <TextField
                              label="Valor"
                              variant="outlined"
                              value={new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              }).format(item.total)}
                              style={{ width: '100%', pointerEvents: 'none' }}
                              slotProps={{
                                inputLabel: { shrink: true },
                              }}
                            />
                          </Grid2>
                        </>
                      ))}
                      <LinksAndTotalStyled item sx={{ width: '100%' }}>
                        <Grid2
                          container
                          direction="column"
                          alignItems="flex-end"
                        >
                          <Grid2 item>
                            <Typography variant="h4">VALOR TOTAL</Typography>
                          </Grid2>
                          <Grid2 item>
                            <Typography color="secondary" variant="h3">
                              {new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              }).format(payable.total)}
                            </Typography>
                          </Grid2>
                        </Grid2>
                      </LinksAndTotalStyled>
                    </>
                  )}
                </Grid2>
              </BoxStyled>
              <BoxStyled item sx={{ width: matches ? '100%' : '35%' }}>
                <Dropzone
                  file={attachment}
                  setFile={setAttachment}
                  route={`/payables/${payableID}/attachments`}
                />
                <Typography variant="h4" style={{ padding: '50px 0 20px 0' }}>
                  ARQUIVOS
                </Typography>
                {files.map((file) => (
                  <AttachmentsListStyled key={file.path}>
                    <FileNameStyled>
                      {`${file.name}.${file.path.extension}`}
                    </FileNameStyled>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton
                        size="small"
                        onClick={() => {
                          downloadAttachment(file.id, file.path.content_type);
                        }}
                      >
                        <MdDownload size={22} color="#747474" />
                      </IconButton>
                    </div>
                  </AttachmentsListStyled>
                ))}
              </BoxStyled>
            </Grid2>
          )}
        </div>
      </RootStyled>
      {loading ? (
        <CircularProgress size={150} color="secondary" />
      ) : (
        <MobileDivStyled>
          <Header />
          <HeadersLinkStyled>
            <Link to="/client">Início</Link>
            &gt;
            <Link
              to={
                payable !== null &&
                `/constructions-details/${payable.construction.id}`
              }
            >
              Detalhamento de obra
            </Link>
            &gt;
            <Link
              to={
                payable !== null &&
                `/constructions-details/${payable.construction.id}/payables`
              }
            >
              Lançamentos
            </Link>
          </HeadersLinkStyled>

          <CardTitleStyled>
            <Typography variant="body2">
              Vencimento:
              {payable !== null && payable.due}
            </Typography>
            <Typography variant="h3">
              {payable !== null &&
                new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(payable.total)}
            </Typography>
          </CardTitleStyled>
          <CopyToClipboard
            text={
              payable.bank_slip_number !== null ? payable.bank_slip_number : ''
            }
            onCopy={() => alert('Código copiado!')}
          >
            <ButtonCopyStyled size="large">
              <MdContentCopy />
            </ButtonCopyStyled>
          </CopyToClipboard>

          <DetailedPayableStyled>
            <div className="items">
              <Typography variant="body2" color="secondary">
                ITENS DO ORÇAMENTO
              </Typography>
              {payablesItems ? (
                payablesItems.map((item) => (
                  <Typography variant="body2" color="primary">
                    {item.description}
                  </Typography>
                ))
              ) : (
                <Typography variant="body2" style={{ color: '#c1c1c1' }}>
                  Nenhum item associado
                </Typography>
              )}
            </div>
            <div className="supplier">
              <Typography variant="body2" color="secondary">
                FORNECEDOR
              </Typography>
              <Typography variant="body2" color="primary">
                {payable !== null && payable.supplier.name}
              </Typography>
            </div>
            <div className="supplier-category">
              <Typography variant="body2" color="secondary">
                CATEGORIA DO FORNECEDOR
              </Typography>
              {payable !== null && payable.payable_items.length ? (
                payable.payable_items.map((items) => (
                  <Typography variant="body2" color="primary">
                    {items.category.name}
                  </Typography>
                ))
              ) : (
                <Typography variant="body2" color="primary">
                  {payable !== null && payable?.category?.name}
                </Typography>
              )}
            </div>
            <div className="description">
              <Typography variant="body2" color="secondary">
                DESCRIÇÃO DO LANÇAMENTO
              </Typography>
              {payable !== null && payable.description ? (
                <Typography variant="body2" color="primary">
                  {payable !== null && payable.description}
                </Typography>
              ) : (
                <Typography variant="body2" style={{ color: '#c1c1c1' }}>
                  Nenhuma descrição adicionada
                </Typography>
              )}
            </div>
          </DetailedPayableStyled>
          <div>
            <Typography variant="h3" style={{ marginLeft: 20 }}>
              Anexos
            </Typography>
            {files.length ? (
              files.map((file) => (
                // eslint-disable-next-line
                <AttachmentsStyled onClick={() => downloadAttachment(file.id)}>
                  <BsDownload />
                  <Typography variant="body2" style={{}}>
                    {`${file.name}.${file.path.extension}`}
                  </Typography>
                </AttachmentsStyled>
              ))
            ) : (
              <Typography
                variant="body2"
                style={{ color: '#c1c1c1', marginLeft: 20 }}
              >
                Nenhuma anexo adicionado
              </Typography>
            )}
          </div>
        </MobileDivStyled>
      )}
    </>
  );
}
